import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "percentageField", "amountField"]

  connect() {
    this.toggle()
  }

  disconnect() {
    if (this.hasPercentageFieldTarget) this.percentageFieldTarget.classList.remove("hidden")
    if (this.hasAmountFieldTarget) this.amountFieldTarget.classList.remove("hidden")
  }

  change() {
    this.toggle()
  }

  toggle() {
    const value = this.selectTarget.value
    if (value === "percentage") {
      this.percentageFieldTarget.classList.remove("hidden")
      this.amountFieldTarget.classList.add("hidden")
    } else if (value === "fixed") {
      this.percentageFieldTarget.classList.add("hidden")
      this.amountFieldTarget.classList.remove("hidden")
    }
  }
}
